import { React,useEffect } from "react";

import {
    BrowserRouter as Router,
    Routes,
    Route,
} from "react-router-dom";
import Home from "./pages";
import Profile from "./pages/Profile";
import AddTeam from "./pages/addTeam";
import LogIn from "./pages/LogIn";
import Logout from "./pages/Logout";
import SignUp from "./pages/Signup";
import { SnackbarProvider } from "notistack";
import SignlePage from "./pages/Single";

import Callback from "./pages/Callback";
import InvoicePage from "./pages/InvoicePage";
import TeamProfile from "./pages/teamProfile";
import AxisDetails from "./pages/AxisDetails";
import AboutUs from "./components/AboutUs";
import GalleryPage from "./pages/GalleryPage";
import VisitPage from "./pages/VisitPage";
import ForgotPassword from "./pages/ForgotPassword";
import Terms from "./pages/Terms";
const Page = ({ title, children }) => {
  useEffect(() => {
    document.title = title; // Set the document title
  }, [title]);

  return <>{children}</>;
};
function App() {

  return (
    
    <SnackbarProvider maxSnack={3}>

    
    <Router basename="">
      <Routes>
          <Route path="/" element={<Page title="خانه :: جشنواره و مسابقات فناوری‌های نوین در صنعت آب و برق کارون کاپ"><Home /></Page>} />
          <Route path="/api/pay/callback/pay/result" element={<Page title="خانه :: جشنواره و مسابقات فناوری‌های نوین در صنعت آب و برق کارون کاپ"><Callback /></Page>} />
          <Route path="/LogIn" element={<Page title="ورود :: جشنواره و مسابقات فناوری‌های نوین در صنعت آب و برق کارون کاپ"><LogIn /></Page>} />
          <Route path="/forgot-password" element={<Page title="فراموشی رمز عبور"><ForgotPassword /></Page>} />
          <Route path="/Logout" element={<Logout />} />
          <Route path="/profile" element={<Page title="حساب کاربری :: جشنواره و مسابقات فناوری‌های نوین در صنعت آب و برق کارون کاپ"><Profile /></Page>} />
          <Route path="/add-team" element={<AddTeam />} />
          <Route path="/sign-up" element={<Page title="ثبت نام :: جشنواره و مسابقات فناوری‌های نوین در صنعت آب و برق کارون کاپ"><SignUp /></Page>} />
          <Route path="news/:id" element={<Page title="کارون کاپ"><SignlePage /></Page>} />
          <Route path="/invoice" element={<Page title="کارون کاپ"><InvoicePage /></Page>} />
          <Route path="/about" element={<Page title="درباره کارون کاپ"><AboutUs /></Page>} />
          <Route path="/terms" element={<Page title="قوانین و مقررات"><Terms /></Page>} />
          <Route path="/teams/:pk/profile/" element={<Page title="پروفایل تیم" ><TeamProfile /></Page>} />
          <Route path="/shenasname/:id" element={<Page title="دیدن طرح های محور"><AxisDetails /></Page>}  />
          <Route path="/gallery" element={<Page title="گالری جشنواره کارون کاپ" ><GalleryPage /></Page>} />
          <Route path="/free-visit" element={<Page title="رزرو حضور در جشنواره کارون کاپ"><VisitPage /></Page>  }  />
      </Routes>
    </Router>

  </SnackbarProvider>
  );
}

export default App;
